import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { App } from './app/app';

if (environment.sentryDsn) {
  Sentry.init({
    dsn: environment.sentryDsn,
    environment: environment.production ? 'production' : 'development',
    enabled: environment.production,
    tracesSampleRate: 0.1,
  });
}

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
